import React, { useState } from "react";
import { Stack, Typography, styled, IconButton } from "@mui/material";
const Card = styled(Stack)(({ theme }: any) => ({
  width: "100%",
  height: "285px",
  background: theme.palette.common.white,
  border: `2px solid ${theme.palette.common.borderGrey}`,
  "& .shadow-button": {
    color: theme.palette.common.black,
    background: theme.palette.common.white,
    borderRadius: "15px",
    boxShadow: `0px 0.866667px 3.46667px rgba(0, 0, 0, 0.25)`,
  },
}));

interface VirtualEventCardInterface {
  image: string;
  date: string;
  title: string;
  category: string;
}
const VirtualEventCard = ({
  image,
  title,
  date,
  category
}: VirtualEventCardInterface) => {
  const [bookmarked, setBookmarked] = useState(false);

  return (
    <Card p={2} spacing={2}>
      <img
        src={image}
        alt={title}
        height="169px"
        style={{ objectFit: "cover" }}
      />
      <Stack spacing={1.5}>
        <Typography
          color={(theme: any) => theme.palette.common.grey}
          variant="body1"
        >
          {date}
        </Typography>
        <Typography color="primary" variant="h4">
          {title}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography
          color={(theme: any) => theme.palette.common.darkGrey}
          variant="body1"
        >
          {category}
        </Typography>
        <IconButton
          color="secondary"
          className="shadow-button"
          onClick={() => setBookmarked(!bookmarked)}
        >
          {bookmarked ? (
            <i className="fas fa-bookmark" />
          ) : (
            <i className="far fa-bookmark" />
          )}
        </IconButton>
      </Stack>
    </Card>
  );
};
export default VirtualEventCard;
